/**
 * @file
 */

export default (Drupal, once) => {

  Drupal.behaviors.colorThiefHero = {
    attach (context) {
      once('hero-component', '.block-views-blockhero-components-block-1', context).forEach(function () {

        // Color Thief
        // eslint-disable-next-line no-undef
        const colorThief = new ColorThief()
        const imgDiv = document.querySelector('.field--name-field-hero-block-photo, .field--name-field-media-image')
        const img = document.querySelector('.field--name-field-hero-block-photo img, .field--name-field-media-image img')

        if (!img || !imgDiv) return // Skip if image elements not found

        // Make sure image is finished loading
        if (img.complete) {
          const arr = colorThief.getColor(img)
          imgDiv.style.backgroundColor = 'rgb(' + arr.join(', ') + ', 0.5)'
        } else {
          img.addEventListener('load', function() {
            const arr = colorThief.getColor(img)
            imgDiv.style.backgroundColor = 'rgb(' + arr.join(', ') + ', 0.5)'
          })
        }

      })
    }
  }
}
